import { ModalShell } from '@/components/common/modal-shell';
import { ObjectShowcase } from '@/components/common/object-showcase';
import { BookDetailCard } from '@/components/cards/book-detail-card';
import { roomBooks } from '@/config';
import { useMediaQuery } from '@/hooks/use-media-query';
import { useRoomStore } from '@/stores/room-store';

export function BookDialog() {
  const panel = useRoomStore((state) => state.panel);
  const bookId = useRoomStore((state) => state.selectedBookId);
  const closePanel = useRoomStore((state) => state.closePanel);
  const isDesktop = useMediaQuery('(min-width: 720px)');
  const book = roomBooks.find((item) => item.id === bookId);
  if (panel !== 'book' || book === undefined) return null;
  const open = true;

  const content = <BookDetailCard book={book} />;
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) closePanel();
  };

  if (isDesktop) {
    return (
      <ObjectShowcase
        layout="bookshelf-split"
        open={open}
        onOpenChange={handleOpenChange}
        title={book.title}
        description="书架上的一本书"
      >
        {content}
      </ObjectShowcase>
    );
  }

  return (
    <ModalShell
      open={open}
      onOpenChange={handleOpenChange}
      title={book.title}
      description="书架上的一本书"
    >
      {content}
    </ModalShell>
  );
}
